/**
 * Control DataChannel protocol types — mirror `host-agent/core/src/proto.rs::ControlMessage`.
 * Sent both directions: each side observes its local clipboard and pushes changes; receiver
 * de-dupes against the most recent value seen.
 */

export interface MonitorInfo {
  index: number;
  name: string;
  width: number;
  height: number;
  active: boolean;
}

export type ControlMessage =
  | { type: 'clipboard_text'; data: string }
  | { type: 'ping'; id: number }
  | { type: 'pong'; id: number }
  | { type: 'cursor_position'; x: number; y: number }
  | { type: 'text_edit_focus'; active: boolean }
  | { type: 'monitor_list'; monitors: MonitorInfo[] }
  | { type: 'monitor_select'; index: number }
  | { type: 'set_quality'; level: QualityLevel };

/**
 * Picture-quality selector value. `'auto'` engages the host-side adaptive controller (sender BWE +
 * CPU guard, sharpness-first); the rest pin a manual preset and mirror
 * `host-agent/core/src/encoder.rs::QualityLevel`.
 */
export type QualityLevel = 'auto' | 'low' | 'medium' | 'high' | 'max';

export function sendControl(channel: RTCDataChannel | null, msg: ControlMessage): boolean {
  if (!channel || channel.readyState !== 'open') return false;
  try {
    channel.send(JSON.stringify(msg));
    return true;
  } catch {
    return false;
  }
}
